var exports = {
  "M0": "bar__j01UCF",
  "kL": "container__kvek_L",
  "aL": "legal__Ts6nlt",
  "UU": "legalList__gYPndj",
  "el": "legalLink__Qn3hUp",
  "Cv": "copyright__oSt0r0",
  "rT": "socialAndLocale__EkgfvV",
};

module.exports = exports;
